import { render } from "./IconFloorPlan.vue?vue&type=template&id=1cc660f0"
import script from "./IconFloorPlan.vue?vue&type=script&lang=js"
export * from "./IconFloorPlan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__